import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import useStateRef from 'react-usestateref';

const SortingPaginantion = ({ containerObject ,isPagination, isSorting}) => {

    const [recsPerPage, setRecsPerPage] = useState(containerObject && containerObject.viewSize ? containerObject.viewSize : "60")
    const [nrpp, setNrpp] = useState(containerObject && containerObject.nrpp ? containerObject.nrpp : "")
    const [search, setSearch, searchRef] = useStateRef("");
    const [activePage, setActivePage] = useState(containerObject && containerObject.pagination && containerObject.pagination.currentPage ? containerObject.pagination.currentPage : "")
	const [sortBy, setSortBy] = useState(containerObject.sortBy)   
    const history = useHistory();

    useEffect(() => {
        //search = window.location.search
        setSearch(window.location.search)
      }, [])

	 const handleNrpp = (event) => {
        let params = new URLSearchParams(searchRef.current)
        //params.set("viewSize",event.target.value)
    	history.push(event.target.value)
     }

	 const handleSortBy = (event) => {
        var value = event.target.value
        var selectedSortBy = null;
        if(document.getElementById(value)) {
            selectedSortBy = document.getElementById(value).getAttribute("selectedSort")
        }
        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push({
                "event": "sort_items",
                "sort_by_option": selectedSortBy
            });
        }
	    history.push(value)
	  }

    const constructUrl = (url, no, recPerPage) => {
        let params = new URLSearchParams(searchRef.current)
        params.set("viewSize", recPerPage)
        params.set("viewIndex", no)
        var parameters = params.toString();
        return "?" + parameters
    }

    return (
        <>
            <div className="category-list-bar category-list-bar-mobile-view">
                <div className="row justify-content-between">
                    <div className={`col-12 col-md-6 ${isPagination ? "" : "d-none d-lg-block"}`}>
                        <nav aria-label="Page navigation example">
                            <ul class="c-pagination pagination justify-content-start pagination-lg">
                                {containerObject.showPagination && containerObject.pagination && containerObject.pagination.pages ? containerObject.pagination.pages.map((page, index) => {

                                    return (
                                        <>
                                            {index == 0 ?
                                                <li className={`page-item ${page.clickable == "true" ? "" : "disabled-page-style disabled"}`}>
                                                    <Link className={`page-link disabled-page-font-style ${page.clickable} ${page.clickable == "true" ? "" : "pe-none"}`}
                                                        to={constructUrl(page.url, ((((Number(activePage) - 1) * recsPerPage)) - recsPerPage), recsPerPage)}
                                                    >
                                                        <span aria-hidden="true">«</span>Previous
                                                    </Link>
                                                </li>
                                                :
                                                index === containerObject.pagination.pages.length - 1 ?
                                                    <li className={`page-item ${page.clickable == "true" ? "" : "disabled-page-style disabled"}`}>
                                                        <Link className={`pagination a product-list-a page-link disabled-page-font-style ${page.clickable == "true" ? "" : "pe-none  "}`}
                                                            to={constructUrl(page.url, ((((Number(activePage) + 1) * recsPerPage)) - recsPerPage), recsPerPage)}
                                                        >
                                                            Next <span aria-hidden="true">»</span>
                                                        </Link>
                                                    </li>
                                                    :
                                                    <li className={`page-item ${containerObject.pagination.currentPage == page.pageNo ? "disabled-page-style disabled" : ""}`}>
                                                        <Link className={`page-link disabled-page-font-style ${page.selected == "true" ? "active-link" : ""} ${page.clickable == "true" ? "" : "pe-none"} `} to={page.url ? page.url : ""}>{page.pageNo}</Link>
                                                    </li>
                                            }
                                        </>
                                    )
                                }) : ""}



                                {/*<li class="page-item">
										<Link class="page-link" href="" tabindex="-1" aria-disabled="true"><span aria-hidden="true">«</span>Previous</Link>
									</li>
									
									<li class="page-item">
			                        	<Link class="page-link" href="">Next <span aria-hidden="true">»</span></Link>
			                        </li>*/}
                            </ul>
                        </nav>
                    </div>
                    <div className={`col-12 col-md-6 ${isSorting ? "":"d-none d-lg-block"}`}>
                        <div className="row">
                            <div className="col-7 col-md-5  justify-content-start">
                                <div className="perpage-view">
                                    <select onChange={handleNrpp} className="form-select form-select-sm" aria-label=".form-select-lg" example="">
                                        {nrpp ? nrpp.map((value, index) => {
                                            return (
                                                <option selected={value.selected == "true" ? "selected" : value.display == recsPerPage ? "selected" : ""} value={value.value}>{value.display}</option>
                                            )
                                        }) : ""}
                                    </select>
                                    <label for="example" className="form-label d-none d-lg-block">Per page</label>
                                </div>
                            </div>
 
							<div className="col-5 col-md-7  justify-content-end d-flex">
								<div className="perpage-view sortby-view">
									<label for="example" className="form-label d-none d-lg-block">Sort by</label>
									<p className="cb-label"></p>
									<select className="form-select form-select-sm" aria-label=".form-select-lg" example="" onChange={handleSortBy} >
										{sortBy ? sortBy.map((value, index) => {
											return (
												<option selected={value.selected == "true" ? "selected" : ""} id={value.value} selectedSort={value.display} value={value.value}>{value.display}</option>
											)
										}) : ""}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default SortingPaginantion